module.exports = __webpack_public_path__ + "img/need.108ad28d.png";